import { ContextualPrivatePartManager } from '../classes/contextual-private-parts-manager.class';

export const GLOBAL_CONTEXTUAL_PRIVATE_PARTS_MANAGER =
   new ContextualPrivatePartManager();
